
export const FILTER = {
    "filter_id": "",
    "comparison": "",
    "order_id": "",
    "ordering": 0,
    "type": 0,
    // "scope_type" : 0,
    "value_1": "",
    "value_2": "",
    "where_type": ""
}



export const REPORT = {
    name: "",
    type: 1,
    scope_type: 0,
    group: "Default",
    order_1: 0,
    order_2: 0,
    order_3: 0,
    columns: [],
    cached_row_total: null,
    date_changed: 0,
    filters: [],
    clerk: "",
    report_id: null,
}

export const ORDER = {
    "cancel_date": null,
    "clerk_code": "",
    "condition_code": " ",
    "customer": null,
    "customer_po": "",
    "default_supplier": false,
    "exchange_rate": 1,
    "invoice": "",
    "invoice_date": null,
    "invoice_price": null,
    "is_single_title_order": false,
    "ms_split": [],
    "note": [],
    "order_id": "",
    "order_number": "",
    "order_separator": "",
    "po_number": "",
    "primary_code": "",
    "quantity": 0,
    "review_days": 0,
    "status": "Pend",
    "status_date": 0,
    "supplier": "HCP",
    "supplier_discount": 45,
    "supplier_name": "",
    "supplier_currency": "",
    "supplier_country": "",
    "title": "",
    "prepay_issue_id": null,
    "pubstock_onhand": "",
    "pubstock_onorder": "",
    "pubstock_sell_price": 0,
    "pubstock_supplier": "",
    "req_date": null,
}



export const CUSTOMER = {
    "alert_message": "",
    "attention": "",
    "address_1": "",
    "address_2": "",
    "bill_to": "",
    "birthday": "",
    "bo": "",
    "cancel": 0,
    "city": "",
    "combine_po": "",
    "communication_preference": "",
    "country": "",
    "credit_limit": 0,
    "discount": 0,
    "edi_codes": "",
    "email": "",
    "enter_date": "",
    "fax": "",
    "frequent_buyer": false,
    "frequent_buyer_point": 0,
    "frequent_buyer_recipient": "",
    "get_deposit": false,
    "interest_1": "",
    "interest_2": "",
    "interest_3": "",
    "interest_4": "",
    "last_order_date": "",
    "location": "",
    "name": "",
    "note": "",
    "note_keynum": "",
    "notes": "",
    "over_due": "",
    "person_id": "",
    "phone": "",
    "phone_2": "",
    "postal_code": "",
    "province": "",
    "rep": "",
    "sales_3": 0,
    "sales_last": 0,
    "sales_this": 0,
    "san": "",
    "ship_to": "",
    "ship_via": "",
    "shop": "",
    "tax_exempt": "",
    "tax_exempt_2": "",
    "tax_group_code": "",
    "tax_number": "",
    "term": "",
    "web_access": "",
}

export const CALCULATED_TOTALS = {
    "discounts": 0,
    "item_total": 0,
    "sub_total": 0,
    "tax_total": 0,
    "taxes": [],
    "total": 0
}


export const TRANSACTION = {
    "posh_id": "",
    "header": {
        "posh_id": "",
        "address": null,
        "amount": 0,
        "calculated_totals": null,
        "can_change": 0,
        "cancel_date": 0,
        "clerk_code": "",
        "combine": 0,
        "customer_ar_total": null,
        "customer_bill_to": null,
        "customer_other_helds": null,
        "customer_ship_to": null,
        "date": 0,
        "group": "",
        "hold_till": 0,
        "invoice": "",
        "latest_log": "",
        "locked": "",
        "locked_station": null,
        "locked_station_bm": null,
        "locked_station_bmo": null,
        "log_code": "",
        "log_date": 0,
        "marked": 0,
        "notes": "",
        "partial": 0,
        "per": "",
        "points_earned": 0,
        "points_total": 0,
        "frequent_buyer_redeem": 0,
        "purchase_order": "",
        "reconcile": "",
        "sale_net": 0,
        "sent_via_eps": 0,
        "ship_via": "",
        "stage": "",
        "tax_code": "",
        "terms": "",
        "type": "",
        "address1": "",
        "address2": "",
        "city": "",
        "country": "",
        "email": "",
        "name": "",
        "phone": "",
        "postal_code": "",
        "prov": "",
        "void_": "",
        "person_address1": "",
        "person_address2": "",
        "person_city": "",
        "person_country": "",
        "person_email": "",
        "person_name": "",
        "person_phone": "",
        "person_postal_code": "",
        "person_prov": ""


    },
    "items": []
}


export const TRANSACTION_CAPTURE_PAYMENT = {
    "approved" : false,
	"outcome_unknown" : false,
	"message" : "",
	"result_code" : "",
	"extras" : null
}

export const TRANSACTION_NOTE = {
    "id": "",
    "keynum": "",
    "sequence": 0,
    "parent": "",
    "note": "",
    "timestamp": 0,
    "type": ""
}

export const TRANSACTION_ITEM = {
    "available_onhand": null,
    "binding": "",
    "class": "",
    "clerk_code": "",
    "condition_code": "",
    "cost": null,
    "customer_ship_to": "",
    "cust_po": "",
    "date": 0,
    "discount": null,
    "discount_expected": null,
    "is_captured_payment" : false,
    "item_price": null,
    "points": "",
    "pos_id": "",
    "prepay_issue_id": null,
    "prepay_order_id": null,
    "prepay_redeem_id": null,
    "prepay_status": "",
    "price": null,
    "price_expected": null,
    "primary_code": "",
    "profit_margin": null,
    "quantity": 0,
    "status": "",
    "stc_id": "",
    "tax_code": "1",
    "title": "",
    "total_price": 0,
    "type": "",
    "type_2": "",
    "type_2_status": "",
    "void_": ""


}

export const STUB_PRINTER = {
    "printer_name": "",
    "stub_uri_name": "",
    "stub_friendly_name": ""
}

export const FINALIZE_PRINT_OPTION = {
    "printer": {},
    "printer_type": "",
}

export const FINALIZE_OPTIONS = {
    "print_options": [],
    "sort": ""
}


export const CUSTOMER_ADDRESS = {
    "address_1": "",
    "address_2": "",
    "attention": "",
    "bm_id": 0,
    "city": "",
    "contact_address_id": "",
    "country": "",
    "date_changed": 0,
    "date_created": 0,
    "email": "",
    "enter_date": "",
    "hidden": false,
    "id": "",
    "name": "",
    "person_ship_to_id": "",
    "phone": "",
    "postal_code": "",
    "province": "",
    "notes": ""
};